module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Form', {
    ref: "formInline",
    staticClass: "padding-blank no-margin-item",
    attrs: {
      "inline": "",
      "label-width": 40
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('Input', {
    staticClass: "normal-form-item",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('Select', {
    staticClass: "normal-form-item",
    model: {
      value: (_vm.model1),
      callback: function($$v) {
        _vm.model1 = $$v
      },
      expression: "model1"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticClass: "normal-form-item",
    model: {
      value: (_vm.model1),
      callback: function($$v) {
        _vm.model1 = $$v
      },
      expression: "model1"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-489b6494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/requirement/components/Query.vue
// module id = 15
// module chunks = 0